// 🔹 Firebase uniquement (sans activer Analytics)
import { initializeApp } from 'firebase/app';

// Configuration Firebase
const firebaseConfig = {
  apiKey: 'AIzaSyBIE6SPoIlKm4QpNAM7H_-CwMBq-WIAYzg',
  authDomain: 'qronde-1d694.firebaseapp.com',
  projectId: 'qronde-1d694',
  storageBucket: 'qronde-1d694.appspot.com',
  messagingSenderId: '820263206764',
  appId: '1:820263206764:web:baa444f9aeeddd683e7d49',
  measurementId: 'G-E7Z1FNWJL1',
};

// Initialisation Firebase
initializeApp(firebaseConfig);

// 🔹 Angular – bootstrap de l’application
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

import { importProvidersFrom } from '@angular/core';
import { FormsModule } from '@angular/forms';

// 🔹 Setup RGPD
import { setupConsentServices } from './app/utils/tarteaucitron-setup';

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [...(appConfig.providers || []), importProvidersFrom(FormsModule)],
})
  .then(() => {
    setupConsentServices(); // ✅ Appel direct après le démarrage Angular
  })
  .catch(err => console.error(err));
